<script lang="ts">
  import { faLoader } from '@itdev-fortawesome/pro-solid-svg-icons/faLoader';
  import { FontAwesomeIcon } from '@fortawesome/svelte-fontawesome';
  import { getContext } from 'svelte';
  import { type Color, type FormModalContext } from '$lib/componentTypes';

  interface Props {
    color?: Color;
    outline?: boolean;
    submit?: boolean;
    form?: string;
    title: string;
    savingTitle: string;
    onClick?: () => void;
  }

  let { color = 'primary', outline = false, submit = false, form, title, savingTitle, onClick }: Props = $props();

  let { saving: savingGetter } = getContext<FormModalContext>('formModal');
  let saving = $derived(savingGetter());
</script>

<button
  class="btn btn-{color}"
  class:btn-outline={outline}
  {color}
  type={submit ? 'submit' : 'button'}
  disabled={saving}
  onclick={onClick}
  {form}
>
  {#if saving}
    <FontAwesomeIcon icon={faLoader} spin class="me-2" />{savingTitle}
  {:else}
    {title}
  {/if}
</button>
